import type { CartState } from '../model/types';

export const EMPTY_CART: CartState = { items: [], comment: '' };

const PREFIX = 'cart:';

/** Корзина принадлежит учётной записи: на общем устройстве другой клиент того же магазина не
 * должен увидеть — и тем более отправить от своего имени — чужие позиции. */
export function cartKey(storeId: string, userId: string): string {
  return `${PREFIX}${storeId}:${userId}`;
}

/** Ключ прежнего формата — общий на магазин. Чья в нём корзина, узнать нельзя, поэтому она не
 * переносится, а удаляется при первом же чтении. */
function legacyKey(storeId: string): string {
  return `${PREFIX}${storeId}`;
}

export function readCart(storeId: string, userId: string): CartState {
  try {
    localStorage.removeItem(legacyKey(storeId));
    const raw = localStorage.getItem(cartKey(storeId, userId));
    if (!raw) return EMPTY_CART;
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !Array.isArray((parsed as CartState).items)) return EMPTY_CART;
    return parsed as CartState;
  } catch {
    return EMPTY_CART;
  }
}

export function writeCart(storeId: string, userId: string, cart: CartState): void {
  try {
    localStorage.setItem(cartKey(storeId, userId), JSON.stringify(cart));
  } catch {
    // приватное окно / заблокировано — корзина живёт только в памяти вкладки
  }
}

/** Явный выход из аккаунта: на устройстве не остаётся ни одной корзины. */
export function clearAllCarts(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key?.startsWith(PREFIX)) keys.push(key);
    }
    for (const key of keys) localStorage.removeItem(key);
  } catch {
    // хранилище недоступно — очищать нечего
  }
}
